var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"ab-icon",class:{
    'loading-spinner': _vm.loading,
    'ab-icon--button': _vm.isButton,
    [_vm.icon]: true,
  },attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }